var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "#7d807f",
    enableBackground: "new 0 0 45.917 45.917",
    viewBox: "0 0 45.917 45.917",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.523 28.334c-0.717 1.155-1.498 2.358-2.344 3.608 7.121 1.065 10.766 3.347 10.766 4.481 0 1.511-6.459 5.054-18.986 5.054-12.528 0-18.988-3.543-18.988-5.054 0-1.135 3.645-3.416 10.768-4.481-0.847-1.25-1.628-2.453-2.345-3.608-7.029 1.327-12.394 4.051-12.394 8.09 0 5.925 11.551 9.024 22.959 9.024s22.958-3.1 22.958-9.024c0-4.039-5.364-6.763-12.394-8.09z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22.96 36.047c1.032 0 2.003-0.491 2.613-1.325 3.905-5.33 10.813-15.508 10.813-20.827 0-7.416-6.012-13.427-13.427-13.427-7.417 0-13.427 6.011-13.427 13.427 0 5.318 6.906 15.497 10.812 20.827 0.613 0.834 1.584 1.325 2.616 1.325zm-5.586-22.417c0-3.084 2.5-5.584 5.585-5.584 3.084 0 5.584 2.5 5.584 5.584s-2.5 5.584-5.584 5.584c-3.085 1e-3 -5.585-2.499-5.585-5.584z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinHeader);
export default __webpack_public_path__ + "static/media/pin-header.00d19c728c0e872c1a7d0a814e8e26a1.svg";
export { ForwardRef as ReactComponent };